// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import Text from "components/typography/Text";
import LangSelector from "components/layout/LangSelector";
import Toggle from "components/layout/Toggle/Toggle";
import ServicePageNavMenu from "components/global/ServicePageNavMenu";

// ** Custom Hooks
import useDarkMode from "hooks/useDarkMode";

// #####################################################

export const SideMenuServicesSection = () => {
	const { t } = useTranslation(["pages"]);

	const language = useSelector((state) => state.globalCommon.language);

	const isDarkMode = useSelector(
		(state) => state.globalCommon?.darkMode?.isDarkMode
	);
	const { toggleTheme } = useDarkMode();

	// #####################################################

	return (
		<Block flex column>
			{/* Przełącznik Trybu Ciemny / Jasny */}
			<Block px={2} flex alignCenter id="variantDark" mt={4}>
				<Text color="grey" size="0.9rem" mr={2}>
					{t("common:darkMode")}:{" "}
				</Text>
				<Toggle onToggle={() => toggleTheme()} toggled={isDarkMode} />
			</Block>
			<Block px={2} mt={5}>
				<Text color="grey" size="0.9rem">
					{t("common:language")}:{" "}
				</Text>
				<LangSelector
					language={language}
					label={t("common:language")}
				/>
			</Block>
			<Block px={2} mt={4}>
				<Text color="grey" size="0.9rem">
					{t("common:service")}:{" "}
				</Text>
				<ServicePageNavMenu />
			</Block>
		</Block>
	);
};

// #####################################################
